// Where a signed-in user belongs after auth, and where the logo/"dashboard"
// links point. Single source of truth — Nav, Auth, AuthVerify and the "/"
// redirect all resolve the same path for a role.
export function roleHome(user) {
  if (user?.role === "admin") return "/admin";
  if (user?.role === "freelancer") return "/freelancer";
  if (user?.role === "seller") return "/seller";
  return "/";
}
